export function decodeApiPayload(payload) {
  const decoded = typeof payload === 'string' ? JSON.parse(payload) : payload;
  if (Array.isArray(decoded)) {
    return decoded;
  }
  if (!decoded || typeof decoded !== 'object') {
    throw new Error('Brendo API returned an invalid result payload.');
  }
  return Object.values(decoded);
}

export function createBrendoClient(fetchImpl = window.fetch.bind(window)) {
  const cache = new Map();

  async function request(path, decode) {
    if (cache.has(path)) {
      return cache.get(path);
    }

    const response = await fetchImpl(path);
    if (!response.ok) {
      throw new Error(`Brendo API request failed with status ${response.status}.`);
    }

    const value = decode(await response.json());
    cache.set(path, value);
    return value;
  }

  function fetchRows(path) {
    return request(path, decodeApiPayload);
  }

  return {
    fetchDataset(datasetKey) {
      return fetchRows(`/api/omics/dumps/${datasetKey}`);
    },
    fetchTransmembraneFocus() {
      return fetchRows('/api/omics/data/all');
    },
    fetchExpression(geneId) {
      const encodedGeneId = encodeURIComponent(geneId);
      return request(
        `/api/omics/plots/counts/${encodedGeneId}/`,
        (payload) => typeof payload === 'string' ? JSON.parse(payload) : payload,
      );
    },
  };
}

export const brendoClient = createBrendoClient();
